export default {
  button: {
    submit: '确定',
  },
  tips: {
    noName: '请输入收藏夹名称',
  },
  delete: '确认删除',
  creat: '确认取消创建此收藏夹?',
};
